export const SUPPORT_INTRO = 'Консультационная поддержка по базовым и практическим аспектам ВЭД (сертификация. торговые барьеры, таможенное регулирование и др.)';

export const SUPPORT_COUNTERPARTY = 'Проверка иностранного контрагента';

export const SUPPORT_COUNTERPARTY_LEAD = 'Специалисты Центра поддержки и развития экспорта «Моспром» оказывают для московских экспортно ориентированных промышленных компаний и компаний сектора АПК услуги по проверке благонадежности потенциальных иностранных покупателей (байеров).';

export const SUPPORT_COUNTERPARTY_REQUIREMENTS_TITLE = 'Требования к заявителю:';

export const SUPPORT_COUNTERPARTY_REQUIREMENTS = [
  'Компания должна быть зарегистрирована в городе Москве.',
  'У компании должна отсутствовать налоговая задолженность.',
];

export const SUPPORT_COUNTERPARTY_HOW_TITLE = 'Как получить поддержку?';

export const SUPPORT_COUNTERPARTY_HOW = [
  'Столичная компания обращается в Центр «Моспром» (по электронной почте или на бумажном носителе).',
  'В течение 2 рабочих дней специалист Центра связывается с представителем компании для обсуждения возможности и объема предоставления меры поддержки.',
];

export const SUPPORT_COUNTERPARTY_PROVIDER = 'Меру поддержки предоставляет: Автономная некоммерческая организация «Центр поддержки экспорта, промышленности и инвестиционной деятельности «Моспром»';

export const SUPPORT_LEAD = 'Информационно-консультационная поддержка – предоставление экспертных заключений и рекомендаций со стороны специалистов АНО «Моспром» московским экспортно ориентированным предприятиям по различным вопросам в сфере ВЭД:';

export const SUPPORT_POINTS = [
  'Условия участия в мерах поддержки АНО «Моспром» и иных региональных и федеральных мерах поддержки',
  'Обеспечение логистики',
  'Условия экспорта и эксплуатации товара на целевом рынке',
  'Порядок проведения международных расчетов',
  'Порядок регистрации и сертификации товаров на зарубежных рынках',
  'Подтверждение происхождения товаров',
  'и иным',
];

export const SUPPORT_POINT_ENDS = [';', ';', ';', ';', ';', ';', '.'];

export const SUPPORT_NOTE = 'Предоставление информационно-консультационной поддержки осуществляется на бесплатной основе в минимально возможные сроки.';

export const SUPPORT_ADVANTAGES_TITLE = 'Основные преимущества информационно-консультационной поддержки АНО «Моспром»';

export const SUPPORT_ADVANTAGES = [
  'Персонализированный подход к экспортно ориентированным компаниям с учетом их опыта в экспорте и отраслевой специфики',
  'Снижение рисков компаний при выходе на целевые рынки',
  'Обеспечение эффективности ВЭД компании',
];
